import ToastProvider from "./components/common/toasts/ToastProvider";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import "./assets/styles/sidebars.css";
import { routes } from "./Routes";
import { MainLayout } from "./components";
import config from "./config";
import MaintenanceBoard from "./components/common/MaintenanceBoard";

// Jedna instancja także przy podwójnym montowaniu w React.StrictMode.
let applicationRouter;

function ApplicationRouter() {
  applicationRouter ??= createBrowserRouter(
    createRoutesFromElements(
      <>
        {routes.loginLayout.map((route, index) => (
          <Route
            key={`ll_${index}`}
            path={route.path}
            element={route.element}
          />
        ))}

        {routes.noSidebarLayout.map((route, index) => (
          <Route
            key={`nsl_${index}`}
            path={route.path}
            element={route.element}
          />
        ))}

        <Route element={<MainLayout />}>
          {routes.mainLayout.map((route, index) => (
            <Route
              key={`ml_${index}`}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
      </>,
    ),
  );
  return <RouterProvider router={applicationRouter} />;
}

function App() {
  return config.maintenance?.enabled === true ? (
    <MaintenanceBoard />
  ) : (
    <ToastProvider>
      <ApplicationRouter />
    </ToastProvider>
  );
}

export default App;
